import type { PricingStepValue } from '../types/pricing.types';
import { formatStepValue } from './pricing-format';

/** Named pricing values (e.g. what was stored with an order), formatted by kind. Display only. */
export function PricingValues({ values, label }: { values: PricingStepValue[]; label: string }) {
  return (
    <dl
      aria-label={label}
      className="border-border divide-border grid grid-cols-1 divide-y rounded-md border text-xs sm:grid-cols-2 sm:divide-y-0"
    >
      {values.map((value) => (
        <div
          key={value.label}
          className="border-border flex items-baseline justify-between gap-4 px-3 py-1.5 sm:border-b"
        >
          <dt className="text-muted-foreground">{value.label}</dt>
          <dd className="text-end tabular-nums">{formatStepValue(value)}</dd>
        </div>
      ))}
    </dl>
  );
}
